import { StyledPlayFeaturedIcon } from '../../../icons/PlayFeaturedIcon'
import { ArticleProgressBar } from './ArticleProgressBar'
import { ArticleActionsContainer } from '../styled/ArticleActionsContainer.styled'
import { ArticlePlayingContainer } from '../styled/ArticlePlayingContainer.styled'
import { StyledSpacer } from '../styled/StyledSpacer.styled'
import { ArticleProgressBarAndTimeContainer } from '../styled/ArticleProgressBarAndTimeContainer.styled'
import { PlayIconAndProgressBarContainer } from '../styled/PlayIconAndProgressBarContainer.styled'
import { IArticleTransformed } from '../types/IArticleTransformed'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import {
    playOrPauseArticle,
    selectAudioState,
    selectCurrentlyPlayingArticle,
    seek15SecsBack,
    copyToClipboardToastThunk,
    selectAudioSpeed,
} from '../data/articleSlice'
import { ArticleTime } from './ArticleTime'
import { StyledPauseFeaturedIcon } from '../../../icons/PauseFeaturedIcon'
import { selectTheme } from '../../theme/data/themeSlice'
import { ArticleNavigationContainer } from '../styled/ArticleNavigationContainer.styled'
import { ArticleActionButtons } from '../styled/ArticleActionButtons'
import { FifteenSecBackButton } from '../styled/FifteenSecBackButton.styled'
import { SpeedAdjustmentButton } from '../styled/SpeedAdjustmentButton.styled'
import { StyledFifteenSecBackIcon } from '../../../icons/FifteenSecBackIcon'
import Popup from '../../../shared/components/Popup'
import { StyledShareIcon } from '../../../icons/ShareIcon'
import SpeedAdjustmentPopup from './SpeedAdjustmentPopup'
import VolumeSlider from './VolumeSlider'
import { StyledVolumeIcon } from '../../../icons/VolumeIcon'
import { SpeedAdjustmentButtonWrapper } from '../styled/SpeedAdjustmentButtonWrapper'
import { isDesktop } from 'react-device-detect'
import { StyledVolumeButton } from '../styled/StyledVolumeButton'
import { StyledShareButton } from '../../widget/styled/StyledShareButton'
import themeUtils from '../../theme/data/themeUtils'
interface IProps {
    article: IArticleTransformed
}

export const ArticleWidgetPlayer = (props: IProps) => {
    const dispatch = useAppDispatch()

    const audioState = useAppSelector(selectAudioState)
    const currentlyPlayingArticle = useAppSelector(selectCurrentlyPlayingArticle)
    const theme = useAppSelector(selectTheme)
    const audioSpeed = useAppSelector(selectAudioSpeed)

    const onClickPlayPause = () => dispatch(playOrPauseArticle())

    const showPauseIcon =
        currentlyPlayingArticle != null && currentlyPlayingArticle.id === props.article.id && audioState === 'playing'

    return (
        <ArticlePlayingContainer {...theme}>
            <ArticleActionsContainer>
                <PlayIconAndProgressBarContainer>
                    {showPauseIcon ? (
                        <StyledPauseFeaturedIcon onClick={onClickPlayPause} />
                    ) : (
                        <StyledPlayFeaturedIcon onClick={onClickPlayPause} />
                    )}
                    <ArticleProgressBarAndTimeContainer>
                        {/* Purely added to ensure progress bar is centered */}
                        <StyledSpacer>Spacer</StyledSpacer>
                        <ArticleProgressBar />
                        <ArticleTime />
                    </ArticleProgressBarAndTimeContainer>
                </PlayIconAndProgressBarContainer>
            </ArticleActionsContainer>

            <ArticleNavigationContainer>
                <ArticleActionButtons style={{ marginLeft: '8px' }}>
                    <FifteenSecBackButton onClick={() => dispatch(seek15SecsBack())}>
                        <StyledFifteenSecBackIcon />
                        <p>15</p>
                    </FifteenSecBackButton>

                    <SpeedAdjustmentButtonWrapper alwaysOpen={true}>
                        <SpeedAdjustmentPopup position={'left'}>
                            <SpeedAdjustmentButton>
                                {audioSpeed}
                                <span>x</span>
                            </SpeedAdjustmentButton>
                        </SpeedAdjustmentPopup>
                    </SpeedAdjustmentButtonWrapper>

                    {isDesktop && (
                        <Popup
                            position='left'
                            content={
                                <div style={{ width: '160px', padding: '2px' }}>
                                    <VolumeSlider
                                        foregroundColor={theme.playColor}
                                        backgroundColor={theme.popupForegroundColor}
                                    />
                                </div>
                            }>
                            <StyledVolumeButton>
                                <StyledVolumeIcon fill={theme.playerIconsColor} stroke={theme.playerIconsColor} />
                            </StyledVolumeButton>
                        </Popup>
                    )}
                </ArticleActionButtons>
                <Popup
                    closeOnClick={false}
                    isNested
                    content={
                        <p
                            style={{
                                fontSize: '14px',
                                lineHeight: '21px',
                                width: 'max-content',
                                color: theme.popupForegroundColor,
                            }}>
                            Article link copied to your clipboard.
                        </p>
                    }>
                    <StyledShareButton onClick={() => dispatch(copyToClipboardToastThunk())}>
                        <span>
                            <StyledShareIcon fill={themeUtils.utils.toRgba(theme.playerIconsColor, 0.6)} />
                        </span>
                        <span>Share</span>
                    </StyledShareButton>
                </Popup>
            </ArticleNavigationContainer>
        </ArticlePlayingContainer>
    )
}
